module.exports = __webpack_public_path__ + "static/media/icon_listar_catalogo.202f4977.svg";